// extracted by mini-css-extract-plugin
module.exports = {"Info":"Home_Info__2OzhF","Orders":"Home_Orders__3jY-J","Logout":"Home_Logout__2VuaM"};